import { render, staticRenderFns } from "./tec.vue?vue&type=template&id=3f962b75&scoped=true"
import script from "./tec.vue?vue&type=script&lang=js"
export * from "./tec.vue?vue&type=script&lang=js"
import style0 from "./tec.vue?vue&type=style&index=0&id=3f962b75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f962b75",
  null
  
)

export default component.exports